"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : STYLES --------------- ++++++++++ */


var _default = {
  field: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'left',
    transition: 'all .15s ease-out 0s',
    // disabled field
    '&.disabled-true': {
      extend: _index.disable
    },
    // form fields
    '& .formelement': {
      // width: pxToEm(260),
      height: (0, _index.pxToEm)(48),
      padding: (0, _index.replacePXinStringWithEM)("0 10px"),
      display: 'flex',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      position: 'relative',
      zIndex: '2',
      transition: _index.theme.animation.general('all'),
      border: (0, _index.replacePXinStringWithEM)("1px solid transparent"),
      borderRadius: (0, _index.pxToEm)(5),
      background: _index.theme.color.supporting.light.swatch,
      color: _index.theme.color.supporting.light.contrast,
      '& .fieldicon': {
        width: (0, _index.pxToEm)(30),
        height: (0, _index.pxToEm)(50),
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-start'
      },
      '& .element': {
        flex: '1',
        height: 'inherit'
      },
      '&:hover': {
        filter: 'brightness(97%)'
      }
    },
    // type overrides
    '&.type': {
      '&-checkbox': {
        display: 'flex',
        flexFlow: 'row nowrap',
        minWidth: '0 !important',
        alignContent: 'center',
        alignItems: 'center',
        margin: '0',
        '& .label': {
          marginBottom: '0'
        },
        '& .formelement': {
          order: '-1',
          height: 'auto',
          backgroundColor: 'transparent',
          border: '0',
          padding: '0',
          '& .element': {
            lineHeight: '0'
          }
        }
      },
      '&-radio': {
        display: 'flex',
        flexFlow: 'row nowrap',
        minWidth: '0 !important',
        alignContent: 'center',
        alignItems: 'center',
        margin: '0',
        '& .label': {
          marginBottom: '0'
        },
        '& .formelement': {
          order: '-1',
          height: 'auto',
          backgroundColor: 'transparent',
          border: '0',
          padding: '0',
          '& .element': {
            lineHeight: '0'
          }
        }
      }
    },
    // state of a form field
    '&.icon-true': {
      '& label': {
        transform: (0, _index.replacePXinStringWithEM)('translate(30px, 160%)')
      }
    },
    '&.isActive-true': {
      '& .formelement': {
        borderColor: function borderColor(props) {
          return props.validateColor ? "".concat(_index.theme.color.primary.medium.swatch, " !important") : "".concat(_index.theme.color.supporting.dark.swatch, " !important");
        },
        boxShadow: function boxShadow(props) {
          return props.validateColor ? '0px 0px 4px 0px rgb(20, 148, 244)' : 'none';
        }
      }
    },
    '&.hasValue-true': {},
    // **** ERROR STATE **** //
    '&.isValid-false': {
      '& .label': {
        color: _index.theme.color.attention.dark.swatch
      },
      '& .formelement': {
        backgroundColor: _index.theme.color.attention.medium.swatch,
        color: _index.theme.color.attention.medium.contrast,
        borderColor: 'transparent'
      },
      '&.isActive-true': {
        '& .formelement': {
          borderColor: "".concat(_index.theme.color.attention.dark.swatch, " !important")
        }
      }
    },
    // variants
    // checkbox surrounded by border
    '&.variant-box': {
      border: "".concat((0, _index.pxToEm)(2), " solid ").concat(_index.theme.color.neutral.light.swatch),
      borderRadius: (0, _index.pxToEm)(4),
      padding: (0, _index.replacePXinStringWithEM)("12px 18px"),
      '& input[type=checkbox]': {
        marginRight: (0, _index.pxToEm)(25)
      },
      '& input[type=radio]': {
        marginRight: (0, _index.pxToEm)(25)
      }
    }
  }
};
exports.default = _default;